import { NavArrowDown } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconNavArrowDown12Line = createIcon(NavArrowDown, 12, "Line");
export const IconNavArrowDown16Line = createIcon(NavArrowDown, 16, "Line");
export const IconNavArrowDown20Line = createIcon(NavArrowDown, 20, "Line");
export const IconNavArrowDown24Line = createIcon(NavArrowDown, 24, "Line");
export const IconNavArrowDown32Line = createIcon(NavArrowDown, 32, "Line");
export const IconNavArrowDown48Line = createIcon(NavArrowDown, 48, "Line");
export const IconNavArrowDown64Line = createIcon(NavArrowDown, 64, "Line");
